import { render, staticRenderFns } from "./CredenciamentoFornecedorTermosHabilitacao.vue?vue&type=template&id=ea8e473a"
import script from "./CredenciamentoFornecedorTermosHabilitacao.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorTermosHabilitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports